import { LOCALE_COOKIE_NAME } from 'constants/cookies';
import { browser } from 'repositories';
import { cookies } from 'utils/cookies/cookies';
import { extractLocaleCode, isRtlLocale } from 'utils/translations';

const setLanguageInformation = (locale: string) => {
  document.documentElement.setAttribute('lang', locale);
  const isCookiePermanent = false;

  cookies.set(
    LOCALE_COOKIE_NAME,
    extractLocaleCode(locale),
    isCookiePermanent,
    browser.getFlywireSubdomain(),
  );
};

const setDirectionInformation = (locale: string) => {
  document.documentElement.setAttribute(
    'dir',
    isRtlLocale(locale) ? 'rtl' : 'ltr',
  );
};

const Locale = (_store: any) => (next: any) => (action: any) => {
  const { type, payload } = action;

  if (type === 'SET_LOCALE') {
    const { locale } = payload;

    setLanguageInformation(locale);
    setDirectionInformation(locale);
  }

  return next(action);
};

export { Locale };
